const translations = {
    farmNameFieldLabel: 'Farm Name'
};

export default translations;
